import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from 'semantic-ui-react';
import styled from 'styled-components';

import * as constants from '@/constants';

export const Warning: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledWarning>
      <Message negative={true}>
        <Message.Header>
          {t('text.subscription.cancellationDeadline.title')}
        </Message.Header>
        <p>
          {t('text.subscription.cancellationDeadline.body', {
            num: constants.INTERVAL_BUSINESS_DAYS + 1,
          })}
        </p>
      </Message>
    </StyledWarning>
  );
};

const StyledWarning = styled.div`
  .ui.negative.message .header {
    color: #c04444;
    font-size: 13px;
    margin-bottom: 10px;
  }

  .ui.negative.message p {
    color: rgba(0, 0, 0, 0.87);
  }
`;
